import { Link } from "react-router-dom";
import arrow from "../images/arrow.svg";
import HoneyBuddyThumbnail from "../images/HoneyBuddy/HoneyBuddy Thumbnail.jpg";

import SMTThumbnail from "../images/SMT/SMT Thumbnail.png";
import CDMThumbnail from "../images/CDM/CDM Thumbnail.png";
import TaskBuddyThumbnail from "../images/TaskBuddy/TaskBuddy Thumbnail.png";
import CakeryThumbnail from "../images/Cakery/Cakery Thumbnail.png";
import MemologThumbnail from "../images/Memolog/Memolog Thumbnail.png";
import WebcrackThumbnail from "../images/WebCrack/Webcrack Thumbnail.png";
import ACMWThumbnail from "../images/ACMW/ACM-W Thumbnail.png";
import { SmallCard, LargeCard } from "./Cards";
export function ProjectInfo({ role, team, toolkit, duration }) {
  const renderList = (data) => {
    if (Array.isArray(data)) {
      return data.map((item, index) => <p key={index}>{item}</p>);
    } else if (typeof data === "string") {
      return data.split(", ").map((item, index) => <p key={index}>{item}</p>);
    } else {
      return <p>{data}</p>;
    }
  };

  return (
    <section id="project-info">
      <div>
        <h1>Role</h1>
        {renderList(role)}
      </div>
      <div>
        <h1>Team</h1>
        {renderList(team)}
      </div>
      <div>
        <h1>Toolkit</h1>
        {renderList(toolkit)}
      </div>
      <div>
        <h1>Duration</h1>
        {renderList(duration)}
      </div>
    </section>
  );
}

export function BigStatement({ children, header }) {
  return (
    <section id="big-statement" className="detail-section">
      <h1>{header}</h1>
      <p>{children}</p>
    </section>
  );
}

export function TwoColumns({ leftContent, rightContent }) {
  return (
    <div className="two-columns-container">
      {leftContent.map((content, index) => (
        <div key={index} className="row">
          <div className="left-item">{content}</div>
          <div className="right-item">{rightContent[index]}</div>
        </div>
      ))}
    </div>
  );
}

export function TextSection({ type, children, header, title }) {
  return (
    <section className={type}>
      <h2 className="section-header">{header}</h2>
      <h1 className="section-title">{title}</h1>
      {children}
    </section>
  );
}

export function ThreeImg({ left, middle, right }) {
  <div className="three-img">
    <img src={left} alt={left} />
    <img src={middle} alt={middle} />
    <img src={right} alt={right} />
  </div>;
}

export function UpNextCard({ project, description, link }) {
  return (
    <Link to={link} className="upnext-section">
      <h1>Up Next: {project}</h1>
      <h2>{description}</h2>
    </Link>
  );
}

export function MoreSection({ exclude = [] }) {
  const smallProjects = [
    {
      id: "cakery",
      img: CakeryThumbnail,
      title: "Cakery",
      subtitle: "Logo and Brand Design",
      link: "/cakery",
    },
    {
      id: "taskbuddy",
      img: TaskBuddyThumbnail,
      title: "Task Buddy",
      subtitle: "Full-Stack, Database",
      link: "/taskbuddy",
    },
    {
      id: "memolog",
      img: MemologThumbnail,
      title: "MemoLog",
      subtitle: "Mobile App Design",
      link: "/memolog",
    },
    {
      id: "webcrack",
      img: WebcrackThumbnail,
      title: "WebCrack",
      subtitle: "Hackathon Finalist",
      link: "/webcrack",
    },
    {
      id: "acmw",
      img: ACMWThumbnail,
      title: "ACM-W Flyers",
      subtitle: "Graphic Design",
      link: "/acmw",
    },
  ];

  const largeProjects = [
    {
      id: "honeybuddy",
      img: HoneyBuddyThumbnail,
      title: "HoneyBuddy",
      subtitle: "UI/UX Design, UX Research",
      description:
        "Improve your quality-of-life with HoneyBuddy, the easy way to build good habits!",
      link: "/honeybuddy",
    },
    {
      id: "smt",
      img: SMTThumbnail,
      title: "Who's on First?",
      subtitle: "Full-stack Development, UI Design",
      description: "A baseball defense simulator tool for coaches and players!",
      link: "/smt",
    },
    {
      id: "cdm",
      img: CDMThumbnail,
      title: "Children’s Discovery Museum",
      subtitle: "UI/UX Design, Redesign",
      description:
        "Playful reimagination of my favorite childhood museum's website!",
      link: "/cdm",
    },
  ];

  return (
    <section id="more-section">
      <img
        src={arrow}
        id="arrow"
        alt="Arrow"
        onMouseEnter={(e) => {
          e.preventDefault();
          document.getElementById("project-section")?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }}
      />
      <section id="project-section" style={{ marginTop: "0" }}>
        <h1 id="additional-project-title">Want to see more?</h1>{" "}
        <div id="project-catalog">
          {" "}
          <h2>Featured Projects</h2>
          {largeProjects
            .filter((project) => !exclude.includes(project.id))
            .map((project) => (
              <LargeCard
                key={project.id}
                img={project.img}
                title={project.title}
                subtitle={project.subtitle}
                description={project.description}
                link={project.link}
              />
            ))}
        </div>
        <h2>Other Projects</h2>
        <div id="small-catalog">
          {smallProjects
            .filter((project) => !exclude.includes(project.id))
            .map((project) => (
              <SmallCard
                key={project.id}
                img={project.img}
                title={project.title}
                subtitle={project.subtitle}
                link={project.link}
              />
            ))}
        </div>
      </section>
    </section>
  );
}

export function ConnectSection() {
  return (
    <section id="connect-section">
      <h1>Connect with me!</h1>
      <a
        href="https://www.linkedin.com/in/tsai-chen-lin"
        target="_blank"
        rel="noopener noreferrer"
        className="primary-button long"
      >
        LinkedIn
      </a>
      <a
        href="https://drive.google.com/file/d/16A4p9NcmJ3YoLXqorWlwKvCWe-b6mVJ0/view?usp=sharing"
        className="primary-button long"
        target="_blank"
        rel="noopener noreferrer"
      >
        Resume
      </a>
      <Link to="/about" className="primary-button long">
        About
      </Link>
    </section>
  );
}
